export enum EnumIconNames{
    Edit = 'icon-edit',
    Delete = 'icon-trash-empty',
    Search = 'icon-search',
    Download = 'icon-download',
    Eye = 'icon-eye',
    EyeOff = 'icon-eye-off',
    LeftOpen = 'icon-left-open',
    LeftBig = 'icon-left-big',
    RightOpen = 'icon-right-open',
    Popup = 'icon-popup',
    LinkExt = 'icon-link-ext',
    Move = 'icon-move',
    Upload = 'icon-upload',
    Cancel = 'icon-cancel',
    CancelCircled = 'icon-cancel-circled',
    Tile = 'icon-th-large',
    Menu = 'icon-menu',
    Basket = 'icon-shopping-basket',
    Plus0 = 'icon-plus',
    Plus1 = 'icon-plus-1',
    Plus2 = 'icon-plus-2',
    Up = 'icon-up-bold',
    List = 'icon-th-list',
    Cog = 'icon-cog',
    Minus0 = 'icon-minus',
    Minus1 = 'icon-minus-1',
    RightBig = 'icon-right-big',
    Search1 = 'icon-search-1',
    User = 'icon-user',
    UserClear = 'icon-user-o',
    UserClear2 = 'icon-user-133',
    UserClear3 = 'icon-user-line-5',
    HelpCircled = 'icon-help-circled',
    TrashEmpty = 'icon-trash-empty',
    Ok = 'icon-ok',
    Check = 'icon-check',
    Heart = 'icon-heart',
    HeartEmpty = 'icon-heart-empty',
    CheckEmpty = 'icon-check-empty',
    DocText ='icon-doc-text',
    SortAltUp = 'icon-sort-alt-up',
    SortAltDown = 'icon-sort-alt-down',
    ShoppingBasket = 'icon-shopping-basket',
}
